import { render } from "./ArenaView.vue?vue&type=template&id=473d8d5f&scoped=true"
import script from "./ArenaView.vue?vue&type=script&lang=js"
export * from "./ArenaView.vue?vue&type=script&lang=js"

import "./ArenaView.vue?vue&type=style&index=0&id=473d8d5f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473d8d5f"]])

export default __exports__